import { manutencao_das_vagas_de_dificientes } from "./manutencao-das-vagas-de-dificientes";
import { manutencao_das_vagas_item } from "./manutencao-das-vagas";
const manutencao_das_vagas = [
  manutencao_das_vagas_de_dificientes,
  manutencao_das_vagas_item,
];

export { manutencao_das_vagas };
